<template>
  <home-layout>
    <div class="container-fluid p-0">
      <section class="container-fluid  bg_principal-about section-one" >
        <div class="container-fluid bg">
          <div class="container-fluid">
            <div class="position-relative">
            <div class="about-us-title mb-3 text-center">{{Title}}</div>
            <p class="about-us-subtitle about-us-subtitle-color1">{{Subtitle}}</p>
          </div>
          </div>
        </div>
      </section>
      <section class="row m-0 justify-content-center bg-color" :style="'background-position-y: 300px;background-color: #FFF !important;width: 100%; height: 588px; background: url(' + GraficosImg + ') no-repeat;'">
        <div class="container">
          <div class="row">
            <div class="col-sm">
              <div class="home-about-us-title" >{{ section2Title }}</div>
              <p class="subtitle-desafio">{{ description1 }}</p>
            </div>
            <div class="col-sm">
              
            </div>
          </div>
        </div>
      </section>
      <section class="row m-0 justify-content-center bg-white" :style="'background-color: #FFF !important;width: 100%; height: 675px; background: url(' + EdificioImg + ') no-repeat;'">
        <div class="container">
          <div class="row">
            <div class="col-sm logo-letra">
              <img class="img-letra" :src="LogoLetras" />
            </div>
            <div class="col-sm">
              <div class="home-about-us-title">{{ section3Title }}</div>
              <p class="subtitle-desafio">{{ description3 }}</p>
            </div>
          </div>
        </div>
      </section>
      <section class="row m-0 justify-content-center bg-color2" :style="'width: 100%; height: 675px; background: url(' + EdificioPlantitaImg + ') no-repeat;'">
        <div class="container">
          <div class="row">
            <div class="col-sm">
              
            </div>
            <div class="col-sm">
              <div class="home-about-us-title">{{ section4Title }}</div>
              <p class="subtitle-desafio">{{ description4 }}</p>
            </div>
          </div>
        </div>
      </section>
      <section class="row m-0 justify-content-center" style="background-color: #0D051A;">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="txt-porque">Por qué Elegir <a style="color: #9747FF;"> KRAUD </a></div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="txt-porque-sub">{{ description5 }}</div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-sm">
              <ul class="text-white" :style="'list-style-image:url(' + ImgLI + ');'">
                <li class="txt-li">{{ option1 }}</li>
                <li class="txt-li">{{ option2 }}</li>
                <li class="txt-li">{{ option3 }}</li>
              </ul>
            </div>
            <div class="col-sm">
              <ul class="text-white" :style="'list-style-image:url(' + ImgLI + ');'">
                <li class="txt-li">{{ option4 }}</li>
                <li class="txt-li">{{ option5 }}</li>
                <li class="txt-li">{{ option6 }}</li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-sm">
              <div class="nota-title">{{ Note }} </div>
            </div>
          </div>
        </div>
      </section>
      
      <section class="row m-0 justify-content-center" :style="'width: 100%; height:600px; background: url(' + LastBack + ') center center / cover no-repeat;'">
        <div class="container text-center">
          <div class="row"><div class="col">
            <img :src="LogoVert" class="logo-vertical-dark">
          </div>
        </div> 
        <div class="row">
          <div class="col-sm">
            <div class="txt-title-contac">
              No esperes más para unirte a la revolución de la inversión industrial. 
            </div>
          </div>
        </div> 
        <div class="row">
          <div class="col-sm txt-subtitle-contac">
            Déjanos tus datos y con gusto nos pondremos en contacto para explicarte cómo es que te podemos invitar a este tipo de proyectos.
          </div>
        </div> 
        <div class="row">
          <div class="col-sm">
            <a href="/contactanos">
              <button class="btn-contactanos">¡Contáctanos!</button>
            </a>
          </div>
        </div>
      </div>
    </section>


      <section v-show="false" class="comments-section2">
        <div class="carousel comentarios-about">
            <div>
              <div class="position-relative" >
                <div class="card text-white">
                  <div class="card-body">
                    <blockquote class="blockquote mb-0">
                      <p class="text-card">A well-known quote, contained in a blockquote element.</p>
                      <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="position-relative" >
                <div class="card">
                  <div class="card-body">
                    <blockquote class="blockquote mb-0">
                      <p class="text-card">A well-known quote, contained in a blockquote element.</p>
                      <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
          </div>
     </section>
      
       
      </div>

      
    <header-info :section=false :isWhoWeAre=true></header-info>
    <footer-info :section=false></footer-info>
  </home-layout>
</template>
<style>
.slick-slide {
    height: auto;
    background-color: #FFFFFF;
    margin: 0px 5px;
}
li {
    display: list-item;
    list-style: unset;
    text-align: -webkit-match-parent;
}
</style>
<script>
import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import ImgLI from '@/assets/about-us/check-broken.png'
import LastBack from '@/assets/about-us/back-last-section.jpg'
import LogoVert from '@/assets/about-us/Logo_Dark_Vertical.png'
import LogoLetras from '@/assets/about-us/Isotipo.png'
import EdificioImg from '@/assets/about-us/edificio.png'
import GraficosImg from '@/assets/about-us/graficas.png'
import EdificioPlantitaImg from '@/assets/about-us/Img_bg_sustentabilidad-degradado.png'
import { getinfoAboutUs } from '@/services/about'
import "@/assets/access.css"


export default {
  name: 'About',
  props: {
  },
  data () {
    return {
      ImgLI:ImgLI,
      LastBack:LastBack,
      LogoVert:LogoVert,
      LogoLetras:LogoLetras,
      EdificioImg:EdificioImg,
      GraficosImg:GraficosImg,
      EdificioPlantitaImg:EdificioPlantitaImg,
      Title:"",
      section2Title:"",
      section3Title:"",
      section4Title:"",
      Subtitle:"",
      section5SubTitle:"",
      option1:"",
      option2:"",
      option3:"",
      option4:"",
      option5:"",
      option6:"",
      Note:"",
      description1:"",
      description2:"",
      description3:"",
      description4:"",
      description5:""
    }
  },
  methods: {
    getContent(content) {
      var MarkdownIt = require('markdown-it'),
      md = new MarkdownIt();
      var result = md.render(content);
      return result
    },
    getinfoAboutUs () {
      getinfoAboutUs().then((response) => { 

        let info = response.data.data.attributes
        
        this.Title = info.Title
        this.section2Title = info.section2Title
        this.section3Title = info.section3Title
        this.section4Title = info.section4Title
        this.Subtitle = info.Subtitle
        this.section5SubTitle = info.section5SubTitle
        this.option1 = info.Option1
        this.option2 = info.Option2
        this.option3 = info.Option3
        this.option4 = info.Option4
        this.option5 = info.Option5
        this.option6 = info.Option6
        this.Note = info.Note
        this.description1 = info.Description1
        this.description2 = info.Description2
        this.description3 = info.Description3
        this.description4 = info.Description4
        this.description5 = info.Description5

      })
    }
  }
  ,
  created () {

    document.body.classList.add("bg_principal")
    $(document).on('ready', function() {
      $('.carousel').slick({
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          speed: 300,
          infinite: true,
          autoplaySpeed: 30000,
          autoplay: true,
          responsive: [
          {
              breakpoint: 1600,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1300,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1100,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                widht:300
              }
            },
            {
              breakpoint: 900,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 576,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      })
    })

    this.getinfoAboutUs()
  },
  mounted () {

  },
  components: {
    HomeLayout,
    HeaderInfo,
    FooterInfo
  }
}
</script>
